import React, { Suspense } from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/google-address-zip'));

export default function (dependencies) {
  const { language } = dependencies;

  const config = {
    autoComplete: 'postal-code',
    label: language['zip-label'],
    placeholder: language.zip_placeholder,
    format: 'integer',
    maxLength: 4,
    api: { errorMessage: language['zip-error'] },
    validators: ['mandatory', 'numberOfDigits:4'],
    behaviour: 'text-input',
  };

  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    config,
  };
}
